/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiUpdateSocialVersionContentMutationRequest, ContentAiUpdateSocialVersionContentMutationResponse, ContentAiUpdateSocialVersionContentPathParams, ContentAiUpdateSocialVersionContent401, ContentAiUpdateSocialVersionContent403 } from "../models/ContentAiUpdateSocialVersionContent";

export function getContentAiUpdateSocialVersionContentUrl(id: ContentAiUpdateSocialVersionContentPathParams["id"], platform: ContentAiUpdateSocialVersionContentPathParams["platform"]) {
  const res = { method: 'PUT', url: `/content-ai/v1/contents/${id}/social-version/${platform}/update` as const }
  return res
}

/**
 * @summary Update social version before publishing
 * {@link /content-ai/v1/contents/:id/social-version/:platform/update}
 */
export async function contentAiUpdateSocialVersionContent(id: ContentAiUpdateSocialVersionContentPathParams["id"], platform: ContentAiUpdateSocialVersionContentPathParams["platform"], data: ContentAiUpdateSocialVersionContentMutationRequest, config: Partial<RequestConfig<ContentAiUpdateSocialVersionContentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ContentAiUpdateSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiUpdateSocialVersionContent401 | ContentAiUpdateSocialVersionContent403>, ContentAiUpdateSocialVersionContentMutationRequest>({ method : "PUT", url : getContentAiUpdateSocialVersionContentUrl(id, platform).url.toString(), data : requestData, ... requestConfig })
  return res.data
}